import { render, staticRenderFns } from "./StandardEditor.vue?vue&type=template&id=1f1343c1&scoped=true"
import script from "./StandardEditor.vue?vue&type=script&lang=js"
export * from "./StandardEditor.vue?vue&type=script&lang=js"
import style0 from "./StandardEditor.vue?vue&type=style&index=0&id=1f1343c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1343c1",
  null
  
)

export default component.exports